import { FormControl, styled } from '@mui/material';

const SEGMENT_CONFIG = [
  { key: 'month' as const, placeholder: 'MM' },
  { key: 'day' as const, placeholder: 'DD' },
  { key: 'year' as const, placeholder: 'YYYY' },
];

function parseValue(value: string | null): { month: string; day: string; year: string } {
  if (!value) return { month: '', day: '', year: '' };
  const [year, month, day] = value.slice(0, 10).split('-');
  return { month: month ?? '', day: day ?? '', year: year ?? '' };
}

interface ReadonlyDateInputSegmentedProps {
  label: string;
  value: string | null;
}

export const ReadonlyDateInputSegmented = ({ label, value }: ReadonlyDateInputSegmentedProps) => {
  const segments = parseValue(value);

  return (
    <FormControl fullWidth>
      <SegmentWrapper
        role='group'
        aria-label={label}
      >
        {SEGMENT_CONFIG.map((seg, i) => {
          const displayValue = segments[seg.key];
          const isActive = displayValue !== '';

          return (
            <Cell
              key={seg.key}
              hasDivider={i > 0}
            >
              <CellLabel active={isActive}>{seg.placeholder}</CellLabel>
              <CellValue>{displayValue}</CellValue>
            </Cell>
          );
        })}
      </SegmentWrapper>
    </FormControl>
  );
};

const SegmentWrapper = styled('div')`
  display: flex;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.action.disabled};
  pointer-events: none;
`;

const Cell = styled('div')<{ hasDivider: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  position: relative;
  border-left: ${({ theme, hasDivider }) => (hasDivider ? `1px solid ${theme.palette.action.disabled}` : 'none')};
`;

const CellLabel = styled('span')<{ active: boolean }>`
  font-size: ${({ theme, active }) => (active ? theme.typography.overline.fontSize : theme.typography.body1.fontSize)};
  color: ${({ theme }) => theme.palette.text.disabled};
  line-height: 1;
  user-select: none;
  position: absolute;
  top: ${({ active }) => (active ? '0px' : '50%')};
  transform: translateY(-50%);
  background: ${({ theme, active }) => (active ? theme.palette.background.paper : 'transparent')};
  padding: ${({ active }) => (active ? '0 4px' : '0')};
  pointer-events: none;
`;

const CellValue = styled('span')`
  text-align: center;
  font-family: inherit;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.text.disabled};
`;
